import { ChangeDetectionStrategy, Component, OnInit, forwardRef } from '@angular/core';
import { CheckoutSuccessComponentDef } from '@df/checkout/checkout-success.component.def';
import { CheckoutSuccessLayoutComponent } from './layout/checkout-success-layout.component';

declare module '@df/checkout/checkout.interfaces' {
    namespace Checkout {
        interface ISuccessData {
            total: number;
            payment_method: IPaymentMethod;
            shipping_method: IShippingMethod;
            billing: IBilling;
            shipping: IShipping;
            totals: ITotals;
        }
        interface IPaymentMethod {
            description?: string;
        }
        interface IShippingMethod {
            description?: string;
        }
        interface IBilling {
            street_1?: string;
            street_2?: string;
            region?: string;
            city?: string;
            postcode?: string;
        }
        interface IShipping {
            street_1?: string;
            street_2?: string;
            region?: string;
            city?: string;
            postcode?: string;
            country_id?: string;
        }
        interface ITotals {
            delivery?: number;
            discount?: number;
            grand_total?: number;
            subtotal?: number;
            tax?: number;
        }
    }
}

@Component({
    selector: 'checkout-success',
    template: '<checkout-success-layout></checkout-success-layout>',
    standalone: true,
    imports: [forwardRef(() => CheckoutSuccessLayoutComponent)],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CheckoutSuccessComponent extends CheckoutSuccessComponentDef implements OnInit {
    protected override onRegister() {
        this.router.navigate(['/account']);
    }
}
